import { render } from "./MyCustomer.vue?vue&type=template&id=a3ddb314&scoped=true"
import script from "./MyCustomer.vue?vue&type=script&lang=js"
export * from "./MyCustomer.vue?vue&type=script&lang=js"

import "./MyCustomer.vue?vue&type=style&index=0&id=a3ddb314&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ddb314"]])

export default __exports__